import controller from '../../../../Scripts/Controller.js';

function HeaderNavControl(button) {
    let navigation;
    let desktopNav;
    let isExpanded = false;
    function init() {
        navigation = document.getElementById('Navigation');
        desktopNav = document.getElementById('desktop-nav');
        button.addEventListener('click', (e) => {
            e.preventDefault();
            isExpanded = navigation.getAttribute('data-nav-expanded') == 'true';
            button.setAttribute('aria-expanded', !isExpanded);
            navigation?.setAttribute('data-nav-expanded', !isExpanded);
            desktopNav?.setAttribute('data-nav-expanded', !isExpanded);
        })
    }
    return {
        init: init
    }
}

controller.add('HeaderNavControl', HeaderNavControl);

export default HeaderNavControl;